import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <div className="d-flex flex-column justify-content-center align-items-center mt-3">
    <FormattedMessage id="notFound" defaultMessage="No search results found" />
  </div>
);
